import React, { FunctionComponent, useCallback, useState } from 'react';
import Logo from 'ui/atoms/logo';
import Translate from 'ui/atoms/translate';
import WideContent from 'core/layout/content/wide-content';
import Section from 'ui/atoms/section';
import PublicationsTable from './publications-table';
import { ProductsForPublicationListNetworkEnum } from 'api/apis/ProductsForPublicationApi';
import PublicationsHistoryModal from './publications-history-modal';
import Link from 'ui/atoms/link';

const filterLabels = {
  isin: 'isin',
  productName: 'productName',
  assetCode: 'assetCode',
  issuer: 'issuer',
  publicationDate: 'publicationDate',
  publicationDateAfter: 'publicationDateAfter',
  publicationDateBefore: 'publicationDateBefore',
  network: 'network',
};

const networkFilterOptions = [
  {
    value: [ProductsForPublicationListNetworkEnum.POLYGON_AMOY, ProductsForPublicationListNetworkEnum.POLYGON_MAINNET],
    label: 'Polygon',
    name: 'polygon',
  },
  {
    value: [
      ProductsForPublicationListNetworkEnum.ETH_DEV,
      ProductsForPublicationListNetworkEnum.ETH_MAINNET,
      ProductsForPublicationListNetworkEnum.ETH_TEST,
    ],
    label: 'Ethereum',
    name: 'ethereum',
  },
  {
    value: [
      ProductsForPublicationListNetworkEnum.STELLAR_DEV,
      ProductsForPublicationListNetworkEnum.STELLAR_PUBNET,
      ProductsForPublicationListNetworkEnum.STELLAR_TEST,
      ProductsForPublicationListNetworkEnum.STELLAR_TESTNET,
    ],
    label: 'Stellar',
    name: 'stellar',
  },
];

const PublicationsPage: FunctionComponent = () => {
  const [historyIdModalOpen, setHistoryIdModalOpen] = useState('');
  const [isin, setIsin] = useState<string | null | undefined>(undefined);

  const onOpenHistory = useCallback((id: string, isin?: string | null) => {
    setHistoryIdModalOpen(id);
    setIsin(isin);
  }, []);

  return (
    <div>
      <WideContent>
        <Section>
          <Link variant="link" href={'https://cashlink.de/de/'}>
            <Logo variant="header" />
          </Link>
        </Section>
      </WideContent>
      <WideContent title={<Translate name="publications.title" />}>
        <Section>
          <Translate name="publications.subtitle" />
        </Section>
        <PublicationsTable
          defaultLimit={50}
          onOpenHistory={(id: string, isin?: string | null) => onOpenHistory(id, isin)}
          singleLabelMultipleOptions={networkFilterOptions}
          singleLabelMultipleOptionsFilterName={filterLabels.network}
        />
        {historyIdModalOpen?.length > 0 && (
          <PublicationsHistoryModal id={historyIdModalOpen} isin={isin} onModalClose={() => onOpenHistory('')} />
        )}
      </WideContent>
    </div>
  );
};

export default PublicationsPage;
